import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {
    Row,
    Col,
    Form,
    InputGroup,
    FormGroup,
    Checkbox,
    Modal,
    ControlLabel,
    FormControl,
    Button
} from 'react-bootstrap';
import MdEmail from 'react-icons/lib/md/email';
import config from  '../../../config';
import {handleFrameTasks, sendDataForIframe}  from 'shared/sharedMethods';
import classNames from 'classnames';
import {
    FETCH_SELLER_PRODUCTS,
    DELETE_SELLER_PRODUCT,
    UPDATE_SELLER_PRODUCT
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import SellerTransactionsTable from 'sellers/products/SellerTransactionsTable';
import formatNumbers  from 'util/formatNumbers';
import {validateEmail}  from 'util/Utils';
import SellerSubscriptionsListTable from "./SellerSubscriptionsListTable";
import {v4 as uuidv4}  from 'uuid'
class SellerSubscriptionsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        this.state = {
            pending: true,
            records: 'dataNotReceived',
            displayShareMyWishList: false,
            displayShareMyWishListInput: false,
            linkToShareInputVisible: false,
            linkToShare:'',
            emailAddress: '',
            perPage: 10,
            ShopifyCustomerID: _.get(this.props, ['location', 'query', 'customerid'], false),
        };
        this.addToCart = _.throttle(this.addToCart, 2000, {
            'leading': true,
            'trailing': false
        });
    };

    componentWillMount() {
        this.search()
    }

    componentDidMount() {
        window.addEventListener("message", this.handleFrameTasks.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleFrameTasks);
    }

    handleFrameTasks(event) {
         handleFrameTasks.call(this, {
            displayMessage: this.props.displayMessage,
            event: event,
            elementID: 'subscriptionsList'
        })
    }

    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }


    search(params = {}) {
        if (this.refs.searchBox) {
            var {queryParams} = this.refs.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, _.omit(params, ['ShareMyWishlist']));
        if (_.get(params, 'displayCurrentPage') && this.refs.pagination) {
            queryParams.page = _.get(this.refs.pagination, 'state.currentPage', 0) + 1
            /* when refreshing the table after user changes some  data */
        }
        if (this.state.sortBy) {
          queryParams.sortBy = this.state.sortBy;
        } else {
           queryParams.sortBy = 'Type' + ':' + 1;
        }
        // queryParams.all=true;
        queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
       queryParams.checkUserEmail = true;
        queryParams.perPage = 10
        queryParams.Deleted = false
       queryParams.Types = ['PriceDrop', 'InStock', 'Favorites']


         queryParams.UserID = this.props.userReducer.user._id;
        var methodData = {
            "endpoint": "/subscriptions",
            'not_display_success_message': true,
        };
        return this.props.makeRequest(queryParams, methodData).then(res => {
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }
            if (this.state.displayShareMyWishListInput) {
                var filteredRecords = _.filter(res.data.data, subscription => {
                    if (_.includes(['PriceDrop', 'InStock'], subscription.Type)) {
                        if (_.get(subscription, ['Product', '_id'])) {
                            return true
                        }
                    } else if (subscription.Type == 'Favorites') {
                        if (_.get(subscription, ['Product', 'ShopifyProductHandle']) && _.get(subscription, ['Product', '_id']) && !subscription.Product.Deleted && subscription.Product.Status == 'Active' && _.get(subscription, 'Product.ProductVariants.0.Quantity', -1) > 0) { /* product exists in TUSH */
                            return true
                        } else if (_.get(subscription, ['SubscriptionCustomData', 'ProductExistsOnlyInShopify']) && _.get(subscription, ['SubscriptionCustomData', 'ShopifyProductHandle'])) { /* product does not exist in TUSH */
                            return true
                        } else if (_.get(subscription, ['SubscriptionCustomData', 'ShopifyProductName'])) {
                            return true
                        }
                    }

                })
                console.log('filteredRecords', filteredRecords);
                this.setState({
                    records: filteredRecords,
                    perPage: filteredRecords.length,
                    pending: false,
                    recordsTotal: filteredRecords.length
                })
            } else {
                this.setState({records: res.data.data, pending: false, recordsTotal: res.data.total})
            }
            sendDataForIframe.call(this, 'subscriptionsList')
        }).catch(err => {
            console.log('err', err);
            this.setState({pending: false})
            sendDataForIframe.call(this, 'subscriptionsList')
        });
    }

    addToCart(row) {
        console.log('in add to cart', {
            'ShopifyProductID': row.ShopifyProductID,
            'ShopifyProductVariantID': _.get(row, 'Product.ProductVariants.0.ShopifyProductVariantID'),
        });
        if (window.parent) {

            window.parent.postMessage({
                eventName: 'customAction',
                methodData: {
                    'ShopifyProductID': row.ShopifyProductID,
                    'ShopifyProductVariantID': _.get(row, 'Product.ProductVariants.0.ShopifyProductVariantID'),
                },
                methodName: 'addProductToCart'

            }, "*");
        }
    }

    copyFavoritesListLink(e) {

        if (!_.size(_.get(this.refs.table, 'state.selectedRecordIDs', []))) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please select the products that you wish to share',
            });
            this.setState({pending: false})
            return;
        }
        var selectedFavoritesIDs = _.map(_.get(this.refs.table, 'state.selectedRecordIDs', []), id=>{
            return encodeURIComponent(id)
        })
        this.setState({
            linkToShare: config.getEnvironment().clientSideURL +'/client/data/favorites?userID='+_.get(this.props.userReducer.user, 'ShopifyCustomerID')+'&recordIDs='+selectedFavoritesIDs.join(','),
           // config.getEnvironment().shopify.shopUrl + '/'+_.get(this.props.userReducer.user, 'ShopifyCustomerID')  + '/favorites?ids='+selectedFavoritesIDs.join(',')
        },function() {

            if (document.queryCommandSupported('copy')) {
                var textField = document.createElement('textarea')
                textField.innerText =this.state.linkToShare
                document.body.appendChild(textField)
                textField.select()
                document.execCommand('copy')
                textField.remove()
                this.props.displayMessage({
                    'messageCode': 'Link to share copied to the clipboard',
                });

            } else {
                this.props.displayMessage({
                    'messageCode': 'Please, copy this link from the input below',
                });
            }
            this.setState({pending: false});

        })


    }

    shareFavoritesList() {
        if (!this.state.emailAddress) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify email address',
            });
            this.setState({pending: false})
            return;
        }
        if (!validateEmail(this.state.emailAddress)) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify valid email address',
            });
            this.setState({pending: false})
            return;
        }
        var methodData = {
            "endpoint": '/share-subscriptions',
            type: "post",
            messageCode: 'Success! Your wishlist has been sent!'
        };
        if (!_.size(_.get(this.refs.table, 'state.selectedRecordIDs', []))) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please select the products that you wish to share',
            });
            this.setState({pending: false})
            return;
        }
        this.props.makeRequest({
            emailAddress: this.state.emailAddress,
            UserID: this.props.userReducer.user._id,
            recordIDs: this.refs.table.state.selectedRecordIDs,
            UserName: this.props.userReducer.user.firstName + (_.get(this.props.userReducer.user, 'lastName') ? ' ' + _.get(this.props.userReducer.user, 'lastName') : '')
        }, methodData).then(res => {
            this.setState({pending: false})
            this.hideShareMyWishlistInput()
        }).catch(err => {
            this.setState({pending: false})
        });
    }

    hideShareMyWishlistInput() {
        this.setState({
            displayShareMyWishListInput: false,

        }, () => {
            if (this.refs.table) {
                console.log('this.refs.table', this.refs.table);
                this.refs.table.setState({selectedRecordIDs: []})
            }
            this.search({}).then(() => {
                this.setState({
                    displayShareMyWishList: false,
                }, () => {
                })
            })
        })
    }

    saveRecord(row, formData) {

        var methodData = {
            "endpoint": "/subscriptions/" + encodeURIComponent(row._id),
            type: "patch",
            messageData: {'#1#': 'Subscription'},
            messageCode: 'recordUpdated'
        };
        this.props.makeRequest(formData, methodData).then(res => {
            this.search({displayCurrentPage: true})

        }).catch(err => {
            this.search({displayCurrentPage: true})
        });
    }

    render() {
        console.log(' SellerSubsciptionsPage this state', this.state);

        return (
            <div >
                <div>

                    {(this.state.records !== 'dataNotReceived' ) &&
                    <div>

                        {this.state.recordsTotal == 0 ?
                            <div
                                className="messageBox">{'You have not signed up for any subscriptions yet.'}</div> :
                            <div className="top20" ref={ page => {
                                if (page && !this.pageContent) {
                                    this.pageContent = page;
                                    sendDataForIframe.call(this, 'subscriptionsList')
                                }
                            }}>
                                <Col className="bot20 " md={6} xs={12} lg={5} sm={7}>
                                    {this.state.displayShareMyWishListInput ?
                                        <FormGroup>
                                            <div style={{maxWidth: 450}} className="bot10">Thanks for sharing! Select
                                                the products you wish to share below and enter an email or copy a link
                                                to share.
                                            </div>
                                            <InputGroup style={{display: 'block', maxWidth: 450}}>
                                                <FormControl
                                                    style={{borderColor: '#8294d6'}}
                                                    defaultValue={this.state.Notes}
                                                    className={this.state.Notes ? 'active' : ''}
                                                    onChange={(e) => this.setState({
                                                        emailAddress: e.target.value
                                                    }) }
                                                    placeholder="Email"
                                                    type="text"/>
                                            </InputGroup>
                                            <div style={{maxWidth: 450}}>
                                                <Button className="top10" onClick={(e) => {
                                                    this.hideShareMyWishlistInput()
                                                }}>Cancel</Button>


                                                <Button className="top10  purple  pull-right"
                                                        style={{marginLeft: 50}}
                                                        disabled={this.state.pending || !_.size(_.get(this.refs.table, 'state.selectedRecordIDs', []))}
                                                        onClick={(e) => {
                                                            if (this.state.pending) {
                                                                return
                                                            } else {
                                                                this.setState({pending: true}, function () {
                                                                    this.copyFavoritesListLink(e)
                                                                })
                                                            }
                                                        }}>Copy link to share</Button>

                                                <Button className="top10  purple   pull-right"
                                                        disabled={this.state.pending || !this.state.emailAddress}
                                                        onClick={(e) => {
                                                            if (this.state.pending) {
                                                                return
                                                            } else {
                                                                this.setState({pending: true}, function () {
                                                                    this.shareFavoritesList()
                                                                })
                                                            }
                                                        }}>Send</Button>
                                            </div>
                                            {document.queryCommandSupported('copy') ?
                                                <textarea
                                                    style={{
                                                        visibility:   'hidden'
                                                    }}
                                                    ref={(textarea) => this.linkToShareInput = textarea}
                                                    value={this.state.linkToShare}
                                                /> :
                                                < FormControl type="text"
                                                              componentClass="textarea"
                                                              ref={(textarea) => this.linkToShareInput = textarea}
                                                              className="top10"
                                                              style={{
                                                                  maxWidth: 600,
                                                                  visibility: (this.state.linkToShareInputVisible ? 'visible' : 'hidden')
                                                              }}
                                                              value={this.state.linkToShare}/>
                                            }

                                        </FormGroup>
                                        :

                                        <Button onClick={(e) => {
                                            this.setState({
                                                displayShareMyWishListInput: true,
                                            }, () => {
                                                this.search({all: true}).then(() => {
                                                    this.setState({displayShareMyWishList: true}, () => {
                                                    })
                                                })
                                            })
                                        }} className="top10 btn   purple ">Share My Wishlist</Button>
                                    }
                                </Col>
                                <SellerSubscriptionsListTable
                                    ref={'table'}
                                    onSortChange={this.onSortChange.bind(this)}
                                    saveRecord={this.saveRecord.bind(this)}
                                    addToCart={this.addToCart.bind(this)}
                                    displayShareMyWishList={this.state.displayShareMyWishList}
                                    records={this.state.records}
                                    onSelectHandler={() => {
                                        this.setState({})
                                    }}
                                    search={this.search.bind(this)} {...this.props}  ></SellerSubscriptionsListTable>
                                <PaginationBox
                                    currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                    perPage={ this.state.perPage}
                                    ref={'pagination'}
                                    total={this.state.recordsTotal}
                                    search={this.search.bind(this)}>
                                </PaginationBox>
                                <div className="clearfix  pbot20"></div>
                            </div>}
                    </div>
                    }
                </div>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SellerSubscriptionsPage);
